export type NpcTheme = 'light' | 'dark'

/**
 * # 为什么不再跟系统走（2026-08-29 主题审计）
 *
 * 全站有两套主题属性：`data-theme`（m-* 备忘录色板，顶栏切换器写它）和
 * `data-npc-theme`（npc-lulu-* 色板）。此前 lulu 侧跟系统偏好、切换器只写
 * m 侧——OS 浅色的用户打开应用就是深浅混排，应用内切换也只能切一半。
 * 现在切换器（applyTheme）同步写两个属性，是唯一入口；这里只在启动时
 * 恢复上次选择，没有存过就给设计稿默认的 dark，不再监听系统。
 */
export function resolveNpcTheme(
  prefersLight: boolean,
  override?: NpcTheme | null,
): NpcTheme {
  if (override === 'light' || override === 'dark') return override
  return prefersLight ? 'light' : 'dark'
}

export function applyNpcTheme(root: HTMLElement, theme: NpcTheme): void {
  root.setAttribute('data-npc-theme', theme)
  root.style.colorScheme = theme
}

export function startNpcThemeSync(root: HTMLElement = document.documentElement): () => void {
  let saved: NpcTheme | null = null
  try {
    const v = window.localStorage.getItem('npc-theme')
    if (v === 'light' || v === 'dark') saved = v
  } catch {
    // 读不到就给默认
  }
  applyNpcTheme(root, saved ?? 'dark')
  return () => {}
}
